<template>
    <div>
        <div class="hidden lg:flex h-16 gap-6 relative" v-if='tabs.length > 0'>
            <!-- <button v-for="t in tabs" :key="t.value" v-if='!isLinks'
                @click='click(t)' :ref='t.value'
                class=''
                :class='[tab != null && t.value == tab.value ? "text-black dark:text-white" : ""]'
            >
                {{ t.html }}
            </button> -->

            <template v-for="t in tabs" :key="t.value">
                <div
                    v-if='t.hidden != undefined ? !t.hidden : true'
                    v-tippy="{
                        content: t.disabled != undefined ? t.disabled() : null,
                        placement: 'bottom',
                        maxWidth: '300px',
                    }"
                >   
                <!-- @click='click(t)' -->
                    <NuxtLink :to='t.value'
                        class='h-16 flex items-center'
                        :ref='t.value'
                        :class='[
                            tab != null && t.value == $route.path ? "text-black dark:text-white" : "",
                            t.disabled != undefined && t.disabled() != false ? "text-grey-700 cursor-not-allowed pointer-events-none" : ""
                        ]'
                        :disabled='t.disabled != undefined && t.disabled() != false ? "disabled" : ""'
                    >
                        <p>{{ t.html }}</p>
                    </NuxtLink>
                </div>
            </template>

            <div class="absolute -bottom-px bg-purple-600 h-0.5 transition-all duration-300" :style="bar" />
        </div>

        <Select class='lg:hidden' :options="tabs" @update:value='changeRoute' 
            :value='$route.path' :menuPush="true" :hasShadow='false' menuMaxHeight='1000px'
            boxClass='!bg-white !h-14 !px-4.5' buttonCSS='px-4.5'
        />
    </div>
</template>

<script>
    export default {
        props: {
            tabs: Array,
            load: String,
            // isLinks: { type: Boolean, default: true }
        },

        data() {
            return {
                tab: this.tabs[0],
                bar: { left: '0px', width: '0px' }
            }
        },

        mounted() {
            setTimeout(() => {
                this.setBar();
            }, 200);
        },

        methods: {
            changeRoute(tab) {
                this.$router.push({ path: tab })
            },

            click(tab) {
                this.$emit('change', tab)
            },

            setBar() {
                let button = this.$refs[this.$route.path];

                if (!button) {
                    this.bar = { left: '0px', width: '0px' }
                } else {
                    button = button[0].$el

                    this.bar = {
                        left: button.offsetLeft + 'px',
                        width: button.clientWidth + 'px'
                    }
                }
            }
        },

        watch: {
            $route(to, from) {
                this.setBar()
            }
        }
    }
</script>